import React from "react";
import { Link } from "react-router-dom";
import SEO from "./SEO";

// Simple soft-404 shown when a detail page id doesn't match any item in the
// backing collection. Prevents the previous behaviour of silently falling back
// to the first item (which caused stale content + duplicate URLs for SEO).
const NotFound = ({ section = "This page", backTo = "/", backLabel = "Back home" }) => (
  <div className="px-6 md:px-10 max-w-[820px] mx-auto py-24 text-center" data-testid="not-found">
    <SEO title="Not found" description="The page you're looking for isn't here." />
    <p className="font-serif italic text-[color:var(--ink-mute)]">404</p>
    <h1 className="font-serif text-5xl mt-4">{section} isn't here.</h1>
    <p className="font-serif text-lg text-[color:var(--ink-mute)] mt-6">
      The link may have changed, or the work has been moved from the archive.
    </p>
    <div className="mt-10">
      <Link to={backTo} className="font-serif italic tlink">{backLabel} →</Link>
    </div>
  </div>
);

export default NotFound;
